import ModelsTable from './ModelsTable';

export { createDisplayPreferences } from './ModelsTable';
export default ModelsTable;
